// extracted by mini-css-extract-plugin
export default {"inputNumber":"priceList_inputNumber__oSS08"};